// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"12":"fba51fb1","60":"d4a216e0","158":"7a05344d","213":"c2266a4a","411":"dddd322c","433":"991d7e6f","455":"aeced673","542":"710eebcb","782":"a89d3255"}[chunkId] + ".chunk.js";
};